import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  Button,
  MenuItem,
  MenuList,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  MenuButton,
  Image,
  HStack,
  Img,
  Skeleton,
  useDisclosure,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { useEmployee } from "../../../hooks/useEmployee";
import {
  buildAffiliateLink,
  copyTextToClipboard,
} from "../../../utils/affiliate";
import { formatTableValue } from "./formatTable";
import SearchableSelect from "../../../components/selectForm";
import { AiOutlineMore } from "react-icons/ai";
import iconEdit from "../../../assets/images/employee/edit.svg";
import iconKey from "../../../assets/images/employee/key.svg";
import iconTextFile from "../../../assets/images/employee/file-text (2).svg";
import iconUnlock from "../../../assets/images/employee/unlock.svg";
import iconCheck from "../../../assets/images/booking/check-circle.svg";
import iconLock from "../../../assets/images/employee/lock.svg";
import iconDelete from "../../../assets/images/employee/delete.svg";
import FormEmployee from "../../../components/form/formEmployee";
import useDebounce from "../../../hooks/useDebounce";
import { clientAPI } from "../../../api/client";
import chevronLeft from "../../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../../assets/images/employee/chevron-right.svg";
import ReactPaginate from "react-paginate";
import FormInfo from "../../../components/form/formInfo";
import { employeeCall } from "../../../api/employee";
import { commonCall } from "../../../api/common";
import toast from "react-hot-toast";
import DeleteDialog from "../../../components/dialog/delete";
import PopupChangePassword from "../../../components/popup/popupChangePassword";
import PopupActivateEmployee from "../../../components/popup/popupActivateEmployee";
import PopupProfileCompleted from "../../../components/popup/popupProfileCompleted";
import { useCategories } from "../../../categorys/employee/salesPerson";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import PopupFileDocument from "../../../components/popup/popupFileDocument";
import { employeeDocumentCall } from "../../../api/employeeDocument";
import { brokerDebtCertificateCall } from "../../../api/brokerDebtCertificate";
import { useNavigate } from "react-router-dom";
const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const SalesRelative = ({ department, isRefetchingWithCreate, paramData }) => {
  const {
    isOpen: isOpenDisbursement,
    onOpen: onOpenDisbursement,
    onClose: onCloseDisbursement,
  } = useDisclosure();
  // Stats
  const searchQueryParams = new URLSearchParams({
    department: department,
  }).toString();
  const [stats, setStats] = useState({
    totalEmployees: 0,
    activeEmployees: 0,
    retiredEmployees: 0,
    newEmployees: 0,
  });
  const getStats = async () => {
    const data = await clientAPI(
      "get",
      `/employee/statsEmployeeByDepartment?${searchQueryParams}`,
    );
    if (data) setStats(data);
  };
  useEffect(() => {
    getStats();
  }, [department]);

  const totalEmployee = [
    {
      title: "Tổng nhân viên",
      total: stats?.totalEmployees,
    },
    {
      title: "Nhân viên đang hđ",
      total: stats?.activeEmployees,
    },
    {
      title: "Nhân viên đã nghỉ",
      total: stats?.retiredEmployees,
    },
    {
      title: "Nhân viên mới",
      total: stats?.newEmployees,
    },
  ];

  // table
  const [search, setSearch] = useState("");
  const [branch, setBranch] = useState(null);
  // const [searchDepartment, setSearchDepartment] = useState(null);
  const [supportDepartment, setSupportDepartment] = useState(null);
  const [saleBlock, setSaleBlock] = useState(null);
  const [saleArea, setSaleArea] = useState(null);
  const [jobPosition, setJobPosition] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [statusIsProfileCompleted, setStatusIsProfileCompleted] =
    useState(null);
  const [isBrokerDebtCertificate, setIsBrokerDebtCertificate] = useState(null);
  const [status, setStatus] = useState(null);
  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  }, []);
  //

  //sort
  const [sortStates, setSortStates] = useState({
    fullName: 0,
    code: 0,
    status: 0,
  });

  const handleSort = (field) => {
    setSortStates((prevSortStates) => ({
      ...prevSortStates,
      [field]: prevSortStates[field] === 1 ? -1 : prevSortStates[field] + 1,
    }));
  };

  const {
    employeeData,
    totalPages,
    refetch,
    isLoading,
    isRefetching,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useEmployee(
    department,
    debouncedSearchTerm,
    branch,
    saleBlock,
    saleArea,
    supportDepartment,
    jobPosition,
    sortStates.fullName,
    sortStates.code,
    sortStates.status,
    status,
    statusIsProfileCompleted,
    isBrokerDebtCertificate,
  );
  // console.log(employeeData)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(null, null, 1, shouldFetch);
  // refech create
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }
  const prevIsRefetchingWithCreate = usePrevious(isRefetchingWithCreate);

  useEffect(() => {
    if (
      isRefetchingWithCreate &&
      prevIsRefetchingWithCreate !== isRefetchingWithCreate
    ) {
      refetch();
      getStats();
    }
  }, [isRefetchingWithCreate, prevIsRefetchingWithCreate, refetch]);

  useEffect(() => {
    paramData({
      branchId: branch,
      saleBlockId: saleBlock,
      saleAreaId: saleArea,
      supportDepartmentId: supportDepartment,
      search: debouncedSearchTerm,
      jobPositionId: jobPosition,
      status: status,
      isProfileCompleted: statusIsProfileCompleted,
      isBrokerDebtCertificate: isBrokerDebtCertificate,
    });
  }, [
    paramData,
    debouncedSearchTerm,
    branch,
    saleBlock,
    supportDepartment,
    saleArea,
    jobPosition,
    status,
    statusIsProfileCompleted,
    isBrokerDebtCertificate,
  ]);

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  //
  const historyTableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "STT",
        key: "num",
      },
      {
        label: "TTHĐ",
        key: "status",
      },
      {
        label: "Trạng thái hoàn thiện hồ sơ",
        key: "isProfileCompleted",
      },
      {
        label: "Nguồn giới thiệu",
        key: "referralSource",
      },
      {
        label: "Đã có CCMG",
        key: "isBrokerDebtCertificate",
      },
      {
        label: "Ảnh ĐD",
        key: "avatar",
      },
      {
        label: "MSNV",
        key: "code",
      },
      {
        label: "Họ tên",
        key: "fullName",
      },
      {
        label: "Chức danh",
        key: "jobTitle",
      },
      // {
      //   label: "Khối bộ phận",
      //   key: "department",
      // },
      {
        label: "Khối",
        key: "saleBlock",
      },
      {
        label: "Vùng",
        key: "saleArea",
      },
      {
        label: "Phòng ban",
        key: "supportDepartment",
      },
      {
        label: "Chi nhánh",
        key: "branch",
      },
      {
        label: "SĐT&Email",
        key: "contact",
      },
      {
        label: "Số CCCD",
        key: "identificationNumber",
      },
      {
        label: "Ngày cấp&N/c CCCD",
        key: "identificationNumberInfo",
      },
      {
        label: "Ảnh CCCD mặt trước",
        key: "idCardFrontImage",
      },
      {
        label: "Ảnh CCCD mặt sau",
        key: "idCardBackImage",
      },
      {
        label: "Ảnh VNeID mặt trước",
        key: "vneidFrontImage",
      },
      {
        label: "Ảnh VNeID mặt sau",
        key: "vneidBackImage",
      },
      {
        label: "Chỗ ở hiện tại",
        key: "currentAddress",
      },
      {
        label: "Stk&Ngân hàng",
        key: "bankInfo",
      },
      {
        label: "Ngày vào làm",
        key: "startTime",
      },
      {
        label: "Ngày nghỉ",
        key: "endTime",
      },
    ],
    data: employeeData,
  };
  //

  // const branches = Object.entries(constantData?.branches || {}).map(
  //   ([key, value]) => {
  //     return {
  //       key,
  //       value,
  //     };
  //   }
  // );
  // const formatEntries = (entries) =>
  //   Object.entries(entries || {}).map(([key, value]) => ({
  //     value: key,
  //     label: value,
  //   }));

  // const departments = useMemo(
  //   () => formatEntries(constantData?.departments),
  //   [constantData?.departments]
  // );

  const statusDatas = [
    {
      key: 0,
      value: "Đang làm việc",
    },
    {
      key: 1,
      value: "Đã nghỉ việc",
    },
  ];

  const statusIsProfileCompletedData = [
    {
      key: 1,
      value: "Đã hoàn thiện hồ sơ",
    },
    {
      key: 2,
      value: "Chưa hoàn thiện hồ sơ",
    },
  ];

  const statusIsBrokerDebtCertificate = [
    {
      key: 1,
      value: "Đã có CCMG",
    },
    {
      key: 2,
      value: "Chưa có CCMG",
    },
  ];

  const jobPositions = Object.entries(
    constantData?.jobPositionSaleBussinesData || {},
  ).map(([key, value]) => {
    return {
      key,
      value,
    };
  });

  const branches = Object.entries(constantData?.branches || {}).map(
    ([key, value]) => {
      return {
        key,
        value,
      };
    },
  );

  const supportDepartments = Object.entries(
    constantData?.supportDepartments || {},
  ).map(([key, value]) => {
    return {
      key,
      value,
    };
  });
  // const formatEntries = (entries) =>
  //   Object.entries(entries || {}).map(([key, value]) => ({
  //     value: key,
  //     label: value,
  //   }));

  // const departments = useMemo(
  //   () => formatEntries(constantData?.departments),
  //   [constantData?.departments]
  // );

  const saleAreas = Object.entries(constantData?.saleAreas || {}).map(
    ([key, value]) => {
      return {
        key,
        value,
      };
    },
  );
  // const saleAreas = useMemo(
  //   () => formatEntries(constantData?.saleAreas),
  //   [constantData?.saleAreas]
  // );
  const saleBlocks = Object.entries(constantData?.saleBlocks || {}).map(
    ([key, value]) => {
      return {
        key,
        value,
      };
    },
  );
  // const saleBlocks = useMemo(
  //   () => formatEntries(constantData?.saleBlocks),
  //   [constantData?.saleBlocks]
  // );

  //
  const [dataEdit, setDataEdit] = useState(null);

  // Copy link giới thiệu (affiliate) của nhân viên
  const handleCopyAffiliateLink = async (affiliateCode) => {
    if (!affiliateCode) {
      toast.error("Nhân viên chưa có mã giới thiệu");
      return;
    }

    const copied = await copyTextToClipboard(
      buildAffiliateLink(affiliateCode),
    );
    if (copied) toast.success("Đã copy link giới thiệu");
    else toast.error("Không copy được link, vui lòng copy thủ công");
  };
  const handleOpenEditEmployee = (data) => {
    setDataEdit({
      saleBlockId: data?.saleBlock?._id,
      saleAreaId: data?.saleArea?._id,
      jobTitleId: data?.jobTitle?._id,
      branchId: data?.branch?._id,
      ...data,
    });
  };

  const handleCloseEditEmployee = () => {
    setDataEdit(null);
  };

  //
  const [dataDetail, setDataDetail] = useState(null);
  const handleOpenDetailEmployee = (data) => {
    setDataDetail(data);
  };

  const handleCloseDetailEmployee = () => {
    setDataDetail(null);
  };

  //
  const onSubmit = async (data) => {
    const toastUpdate = toast.loading("Đang cập nhật ...");
    try {
      const { id } = data;
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null,
        ),
      );
      if (filteredData?.file) {
        const { filePath } = await commonCall.uploadAvatar(filteredData?.file);
        if (filePath) filteredData.avatar = filePath;
      }
      delete filteredData.id;
      delete filteredData.file;
      // Ảnh đã bấm "Xóa" trên form (giá trị null, bị lọc ở trên) => gửi "" để BE xoá ảnh cũ
      ["idCardFrontImage", "idCardBackImage", "vneidFrontImage", "vneidBackImage"]
        .filter((key) => data?.[key] === null)
        .forEach((key) => {
          filteredData[key] = "";
        });
      delete filteredData.department;

      if (filteredData?.status === "1") {
        filteredData.endTime = new Date();
      }

      await employeeCall.update(id, { ...filteredData });
      await refetch();
      await getStats();
      setDataEdit(null);
      toast.success("Cập nhật thành công");
    } catch (error) {
      console.log({ error });
    }
    toast.dismiss(toastUpdate);
  };

  // Xác nhận hoàn thiện hồ sơ: HCNS phải chọn nguồn giới thiệu trong popup
  const [dataProfileCompleted, setDataProfileCompleted] = useState(null);
  const handleCloseProfileCompleted = () => setDataProfileCompleted(null);

  const onSubmitIsProfileCompleted = async ({ id, referralSource }) => {
    const toastUpdate = toast.loading("Đang cập nhật ...");
    try {
      await employeeCall.updateStatusIsProfileCompleted(id, {
        isProfileCompleted: true,
        referralSource,
      });
      await refetch();
      await getStats();
      setDataEdit(null);
      setDataProfileCompleted(null);
      toast.success("Cập nhật thành công");
    } catch (error) {
      console.log({ error });
    }
    toast.dismiss(toastUpdate);
  };
  //
  const [dataPassword, setDataPassword] = useState(null);

  const onSubmitPassword = async (data) => {
    const toastUpdate = toast.loading("Đang cập nhật mật khẩu ...");
    const { id, password } = data;
    try {
      await employeeCall.updatePassword({ id, password });
      await refetch();
      await getStats();
      toast.success("Cập nhập mật khẩu thành công");
      setDataPassword(null);
    } catch (error) {
      console.log({ error });
    }
    toast.dismiss(toastUpdate);
  };

  const handleOpenChangePassword = (data) => {
    setDataPassword(data);
  };

  const handleCloseChangePassword = () => {
    setDataPassword(null);
  };

  //
  const [dataActivate, setDataActivate] = useState(null);
  const handleCloseActivate = () => setDataActivate(null);

  const handleChangeEmployeeStatus = async (data) => {
    const { id, status } = data;
    // Đang dừng hoạt động -> mở hoạt động: cho chọn ngày vào làm qua popup
    if (Boolean(status)) {
      setDataActivate(data);
      return;
    }
    // Đang hoạt động -> dừng: giữ nguyên như cũ, ngày nghỉ = ngày ấn dừng
    const toastUpdate = toast.loading("Đang cập nhật trạng thái ...");
    try {
      await employeeCall.updateStatus({ id, status: 1 });
      await refetch();
      await getStats();
      toast.success("Cập nhập trang thái thành công");
    } catch (error) {
      console.log({ error });
    }
    toast.dismiss(toastUpdate);
  };

  const handleActivateEmployee = async ({ id, startTime }) => {
    const toastUpdate = toast.loading("Đang cập nhật trạng thái ...");
    try {
      await employeeCall.updateStatus({ id, status: 0, startTime });
      await refetch();
      await getStats();
      toast.success("Cập nhập trang thái thành công");
      setDataActivate(null);
    } catch (error) {
      console.log({ error });
    }
    toast.dismiss(toastUpdate);
  };

  //
  const [dataDel, setDataDel] = useState(null);
  const handleOpenDeleteEmployee = (data) => {
    setDataDel(data);
  };

  const handleCloseDeleteEmployee = () => {
    setDataDel(null);
  };

  const handleDeleteEmployee = async (data) => {
    const toastUpdate = toast.loading("Đang xóa nhân viên ...");
    const { id } = data;
    try {
      await employeeCall.updateHiddenStatus(id);
      await refetch();
      await getStats();
      toast.success("Xóa thành công");
      setDataDel(null);
    } catch (error) {
      console.log({ error });
    }
    toast.dismiss(toastUpdate);
  };

  const handleDisbursementEmployee = async (id) => {
    const toastUpdate = toast.loading(
      "Đang cập nhật trạng thái sở hữu chúng chỉ môi giới ...",
    );
    try {
      await employeeCall.disbursement(id);
      await refetch();
      await getStats();
      toast.success("Cập nhật thành công");
      setDataEdit(null);
      onCloseDisbursement();
    } catch (error) {
      console.log({ error });
    }
    toast.dismiss(toastUpdate);
  };

  const handleCreateDisbursementEmployee = async (id) => {
    const toastUpdate = toast.loading("Đang tạo tạm giữ CCMG...");
    try {
      const data = {
        employeeId: id,
        amountHeld: 0,
        amountPaid: 0,
      };

      await brokerDebtCertificateCall.create(data);
      await refetch();
      await getStats();
      toast.success("Tạo tạm giữ CCMG thành công");
      setDataEdit(null);
      onCloseDisbursement();
    } catch (error) {
      console.log({ error });
    }
    toast.dismiss(toastUpdate);
  };

  const handleCloseDisbursement = () => {
    setDataEdit(null);
    onCloseDisbursement();
  };

  //
  //file
  const [dataFilePopup, setDataFilePopup] = useState(null);
  const handleOpenFilePopup = (data) => {
    setDataFilePopup(data?.id);
  };

  const handleCloseFilePopup = () => {
    setDataFilePopup(null);
  };

  const handleOpenDisbursement = (e) => {
    setDataEdit(e);
    onOpenDisbursement();
  };

  const submitFileEmployee = async (id, data) => {
    if (Array.isArray(data) && data.length > 0) {
      for (const item of data) {
        if (item?.file) {
          const dataFile = {};

          if (!item?.name) {
            item.name = item?.file?.name;
          } else {
            dataFile.name = item.name;
          }

          if (item?.pathOrigin) {
            dataFile.pathOrigin = item.pathOrigin;
          }

          const { filePath } = await commonCall.uploadFile(
            item?.file,
            "employeeDocument",
            dataFile,
          );
          if (filePath) {
            item.path = filePath;
          }
          delete item.file;
        } else {
          if (item?.name && item?.pathOrigin) {
            const { filePath } = await commonCall.reNameFile({
              name: item?.name,
              pathOrigin: item?.pathOrigin,
              uploadFolder: "employeeDocument",
            });

            if (filePath) {
              item.path = filePath;
            }
          }
        }

        item.employeeId = id;
        item.id = item.id.toString();
        if (item?.fileName) delete item.fileName;
        delete item?.status;
        delete item?.pathOrigin;
        delete item?.init;
      }

      data = data.filter((item) => !(item.path === ""));

      const toastUpdate = toast.loading("Đang cập nhật dữ liệu ...");
      try {
        // console.log(data)
        await employeeDocumentCall.updateOrCreateMany(data);
        await refetch();
        await getStats();
        toast.success("Cập nhật thành công");
        setDataFilePopup(null);
      } catch (error) {
        console.log({ error });
      }
      toast.dismiss(toastUpdate);
    }
  };

  const handleDownloadContract = async (id) => {
    const toastDownload = toast.loading("Đang in hợp đồng dịch vụ ...");

    try {
      const downLoadContract = await employeeCall.downLoadContract(id);

      if (downLoadContract?.items?.filePath) {
        const link = document.createElement("a");
        // link.target = "_blank";
        link.href = `${baseURL}${downLoadContract?.items?.filePath}`;
        link.click();
        if (document.body.contains(link)) {
          document.body.removeChild(link);
        }
      }

      toast.dismiss(toastDownload);
      toast.success("In hợp đồng dịch vụ thành công");
    } catch (error) {
      toast.dismiss(toastDownload);
      console.log({ error });
    }
  };

  const navigate = useNavigate();
  const handleNavigate = (e) => {
    const searchParams = new URLSearchParams({
      employeeId: e?.id || "",
      code: e?.code || "",
      fullName: e?.fullName || "",
    });

    navigate(`/employee-kpi?${searchParams.toString()}`);
  };

  // Bộ lọc hiển thị ngay dưới tiêu đề cột, dùng chung state với thanh lọc phía trên
  const columnHeaderFilters = {
    status: (
      <SearchableSelect
        isShowSearch={false}
        options={statusDatas}
        initialSelectedOption={{ key: null, value: "Tất cả" }}
        setValue={setStatus}
        selectedKey={status}
        width="100%"
        minW="150px"
      />
    ),
    isProfileCompleted: (
      <SearchableSelect
        isShowSearch={false}
        options={statusIsProfileCompletedData}
        initialSelectedOption={{ key: null, value: "Tất cả" }}
        setValue={setStatusIsProfileCompleted}
        selectedKey={statusIsProfileCompleted}
        width="100%"
        minW="150px"
      />
    ),
    isBrokerDebtCertificate: (
      <SearchableSelect
        isShowSearch={false}
        options={statusIsBrokerDebtCertificate}
        initialSelectedOption={{ key: null, value: "Tất cả" }}
        setValue={setIsBrokerDebtCertificate}
        selectedKey={isBrokerDebtCertificate}
        width="100%"
        minW="140px"
      />
    ),
    saleBlock: (
      <SearchableSelect
        isShowSearch={true}
        options={saleBlocks}
        initialSelectedOption={{ key: 0, value: "Tất cả" }}
        setValue={setSaleBlock}
        selectedKey={saleBlock}
        width="100%"
        minW="150px"
      />
    ),
    saleArea: (
      <SearchableSelect
        isShowSearch={true}
        options={saleAreas}
        initialSelectedOption={{ key: 0, value: "Tất cả" }}
        setValue={setSaleArea}
        selectedKey={saleArea}
        width="100%"
        minW="150px"
      />
    ),
    supportDepartment: (
      <SearchableSelect
        isShowSearch={true}
        options={supportDepartments}
        initialSelectedOption={{ key: 0, value: "Tất cả" }}
        setValue={setSupportDepartment}
        selectedKey={supportDepartment}
        width="100%"
        minW="150px"
      />
    ),
    branch: (
      <SearchableSelect
        isShowSearch={false}
        options={branches}
        initialSelectedOption={{ key: 0, value: "Tất cả" }}
        setValue={setBranch}
        selectedKey={branch}
        width="100%"
        minW="150px"
      />
    ),
  };

  return (
    <Flex flexDirection={"column"} gap={{ base: "16px" }}>
      <Flex alignItems={"center"} gap={{ base: "16px" }}>
        {totalEmployee.map((item, index) => (
          <Flex
            w={{ base: "192px" }}
            key={index}
            flexDirection={"column"}
            backgroundColor={"#FFF"}
            p={"16px 42px 16px 16px"}
            borderRadius={{ base: "12px" }}
            gap={{ base: "12px" }}
          >
            <Text
              fontSize={{ base: "15px" }}
              fontWeight={400}
              color="var(--text-color-Subtittle)"
            >
              {item.title}
            </Text>
            <Text fontSize={{ base: "20px" }} fontWeight={500} color={"#000"}>
              {item.total}
            </Text>
          </Flex>
        ))}
      </Flex>
      <Flex
        minHeight="calc(100vh - 297.5px)"
        backgroundColor="var(--color-main)"
        borderRadius={{ base: "12px" }}
        flexDirection={"column"}
      >
        <Flex
          alignItems={"flex-start"}
          gap={{ base: "16px 32px" }}
          flex={"1"}
          flexDirection={"column"}
          p={"16px 0px 12px 16px"}
        >
          <InputGroup
            maxW="42vw"
            minW={"42vw"}
            borderRadius={{ base: "8px" }}
            w={{ base: "100%" }}
          >
            <Input
              placeholder="Nhập MVN, họ tên, sđt..."
              type="text"
              borderRadius={{ base: "8px" }}
              border={{ base: "1px solid var(--color-secondary)" }}
              backgroundColor={"var(--fill-avatar)"}
              onChange={onChangeSearch}
            />
            <InputRightElement
              cursor={"pointer"}
              borderTopRightRadius={"8px"}
              borderBottomRightRadius={"8px"}
              pointerEvents="auto"
              backgroundImage="var(--color-button)"
            >
              <SearchIcon color="var(--color-main)" />
            </InputRightElement>
          </InputGroup>
          <Flex
            alignItems={"center"}
            gap={{ base: "16px 32px" }}
            flex={"1"}
            flexWrap={"wrap"}
            w={"100%"}
          >
            <SearchableSelect
              isShowSearch={true}
              options={jobPositions}
              initialSelectedOption={{ key: 0, value: "Chọn chức vụ" }}
              setValue={setJobPosition}
            />
          </Flex>
        </Flex>
        <Flex
          minHeight="calc(100vh - 365.5px)"
          flexDirection={"column"}
          justifyContent={"space-between"}
          width={"100%"}
        >
          <Skeleton isLoaded={!isLoading && !isRefetching}>
            <TableContainer
              width={"100%"}
              pb={"16px"}
              maxH="calc(100vh - 365.5px)"
              overflowY="auto"
            >
              <Table w={"100%"} variant="unstyled">
                <Thead
                  position="sticky"
                  top="0"
                  zIndex="1"
                  w={"100%"}
                  h={"41px"}
                  color="white"
                  fontWeight="400"
                  backgroundColor="var(--fill-avatar)"
                >
                  <Tr h={{ base: "41px" }}>
                    {historyTableData.headers.map((e, index) => {
                      return (
                        <Td
                          p={"16px 16px 8px 16px"}
                          key={index}
                          border={"none"}
                          color={"#51607B"}
                          fontSize={{ base: "14px" }}
                          w={"20%"}
                        >
                          <Box
                            cursor={"pointer"}
                            onClick={() => {
                              handleSort(e.key);
                            }}
                            textAlign={"center"}
                            fontWeight={"bold"}
                            display={"flex"}
                            gap={"4px"}
                            alignItems={"center"}
                            justifyContent={"center"}
                          >
                            <Text
                              color={
                                (sortStates[e.key] == 1 ||
                                  sortStates[e.key] == -1) &&
                                "var(--color-option-employee-hover)"
                              }
                            >
                              {e.label}{" "}
                            </Text>

                            <Text>
                              {sortStates[e.key] === 1 ? (
                                <TiArrowSortedUp color="var(--color-option-employee-hover)" />
                              ) : sortStates[e.key] === -1 ? (
                                <TiArrowSortedDown color="var(--color-option-employee-hover)" />
                              ) : (
                                ""
                              )}
                            </Text>
                          </Box>
                        </Td>
                      );
                    })}
                  </Tr>
                  <Tr backgroundColor="var(--fill-avatar)">
                    {historyTableData.headers.map((e, index) => {
                      return (
                        <Td
                          key={index}
                          p={"0px 16px 12px 16px"}
                          border={"none"}
                          verticalAlign={"top"}
                        >
                          {columnHeaderFilters[e.key] || null}
                        </Td>
                      );
                    })}
                  </Tr>
                </Thead>
                <Tbody w={"100%"} h={"100%"}>
                  {historyTableData.data?.length > 0 ? (
                    historyTableData.data?.map((e, rowIndex) => {
                      const items = { ...e };
                      delete items.id;
                      delete items.detail;
                      delete items.edit;
                      delete items.export;
                      const keyValues = Object.keys(items);
                      return (
                        <Fragment key={rowIndex}>
                          <Tr
                            w={"100%"}
                            key={rowIndex}
                            h={"72px"}
                            backgroundColor={
                              rowIndex % 2 === 0
                                ? "#transparent"
                                : "var(--fill-avatar)"
                            }
                          >
                            <Td p={"16px 16px 8px 16px"} w={"20%"}>
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                >
                                  <AiOutlineMore fontSize={"20px"} />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleOpenEditEmployee(e?.edit)
                                    }
                                  >
                                    <Image src={iconEdit} /> Chỉnh sửa
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleCopyAffiliateLink(
                                        e?.detail?.affiliateCode,
                                      )
                                    }
                                  >
                                    <Image src={iconTextFile} />
                                    Copy link giới thiệu
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleOpenChangePassword(e?.edit)
                                    }
                                  >
                                    <Image src={iconKey} />
                                    Đổi mật khẩu
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handleOpenFilePopup(e?.edit)}
                                  >
                                    <Image src={iconTextFile} />
                                    Tài liệu
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleDownloadContract(e?.id)
                                    }
                                  >
                                    <Image src={iconTextFile} />
                                    In hợp đồng dịch vụ
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handleNavigate(e)}
                                  >
                                    <Image src={iconTextFile} />
                                    Đánh giá KPI
                                  </MenuItem>
                                  {!e?.isProfileCompleted && (
                                    <MenuItem
                                      gap={"16px"}
                                      onClick={() =>
                                        setDataProfileCompleted({
                                          id: e?.id,
                                          code: e?.code,
                                          fullName: e?.fullName,
                                        })
                                      }
                                    >
                                      <Image src={iconCheck} />
                                      <Text>Xác nhận hoàn thiện hồ sơ</Text>
                                    </MenuItem>
                                  )}

                                  {!!e?.isProfileCompleted && (
                                    <MenuItem
                                      gap={"16px"}
                                      onClick={() =>
                                        setDataProfileCompleted({
                                          id: e?.id,
                                          code: e?.code,
                                          fullName: e?.fullName,
                                          mode: "update",
                                        })
                                      }
                                    >
                                      <Image src={iconCheck} />
                                      <Text>Cập nhật nguồn giới thiệu</Text>
                                    </MenuItem>
                                  )}
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleOpenDisbursement(e?.edit)
                                    }
                                  >
                                    <Image src={iconEdit} /> Cập nhật trạng thái
                                    sở hữu CCMG
                                  </MenuItem>

                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleChangeEmployeeStatus(e?.edit)
                                    }
                                  >
                                    {items?.status ? (
                                      <Image src={iconUnlock} />
                                    ) : (
                                      <Image src={iconLock} />
                                    )}{" "}
                                    <Text
                                      color={
                                        !items?.status &&
                                        "var(--text-red-employee)"
                                      }
                                    >
                                      {!items?.status
                                        ? "Dừng hoạt động"
                                        : "Mở hoạt động"}
                                    </Text>
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleOpenDeleteEmployee(e?.edit)
                                    }
                                  >
                                    <Image src={iconDelete} /> Xóa nhân viên
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width;
                              let whiteSpace;
                              if (keyvalue === "fullName") {
                                width = "116px";
                                whiteSpace = "normal";
                              } else if (keyvalue === "code") {
                                width = "126px";
                              } else {
                                width = "auto";
                                whiteSpace = "inherit";
                              }
                              const isShow =
                                keyvalue === "avatar" ||
                                keyvalue === "code" ||
                                keyvalue === "fullName";
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={"20%"}
                                  key={index}
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    fontWeight={500}
                                    color={"#293755"}
                                    w={width}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                    onClick={
                                      isShow
                                        ? () =>
                                            handleOpenDetailEmployee(e?.detail)
                                        : undefined
                                    }
                                  >
                                    {formatTableValue(
                                      items[keyvalue],
                                      keyvalue,
                                      e.code,
                                      e.id,
                                      onSubmitIsProfileCompleted,
                                    )}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        </Fragment>
                      );
                    })
                  ) : (
                    <Tr>
                      <Td
                        colSpan={historyTableData.headers.length}
                        textAlign="center"
                        padding={"70px 0"}
                      >
                        Không có dữ liệu
                      </Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
            </TableContainer>
          </Skeleton>
          <Flex
            m={"50px 16px 16px 16px"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Text
              fontSize={"14px"}
              fontWeight={500}
              lineHeight={"20px"}
              color={"var(--text-color-Subtittle)"}
            >
              Showing {startEntry} to {endEntry} of {entries} entries
            </Text>
            <HStack spacing={2} justify="flex-end">
              <ReactPaginate
                className="pagination-custom"
                pageCount={totalPages}
                pageRangeDisplayed={3}
                marginPagesDisplayed={1}
                onPageChange={handlePageChange}
                containerClassName={"pagination"}
                activeClassName={"active"}
                breakClassName={"ellipsis"}
                breakLabel={"..."}
                previousLabel={
                  <Img w={"16px"} minW={"16px"} h={"16px"} src={chevronLeft} />
                }
                nextLabel={
                  <Img w={"16px"} minW={"16px"} h={"16px"} src={chevronRight} />
                }
                renderOnZeroPageCount={null}
                forcePage={currentPage - 1}
              />
            </HStack>
          </Flex>
        </Flex>
      </Flex>
      {dataEdit && !isOpenDisbursement && (
        <FormEmployee
          isOpen={!!dataEdit}
          onClose={handleCloseEditEmployee}
          onSubmit={onSubmit}
          defaultValues={dataEdit}
          department={department}
        />
      )}
      {dataDel && (
        <DeleteDialog
          isOpen={!!dataDel}
          onClose={handleCloseDeleteEmployee}
          title={"Xóa nhân viên kinh doanh"}
          description={`Bạn có muốn xóa nhân viên ${dataDel?.fullName} không ?`}
          action={() => handleDeleteEmployee(dataDel)}
        />
      )}
      {dataPassword && (
        <PopupChangePassword
          isOpen={!!dataPassword}
          onClose={handleCloseChangePassword}
          onSubmit={onSubmitPassword}
          defaultValues={dataPassword}
        />
      )}
      {dataProfileCompleted && (
        <PopupProfileCompleted
          isOpen={!!dataProfileCompleted}
          onClose={handleCloseProfileCompleted}
          onSubmit={onSubmitIsProfileCompleted}
          defaultValues={dataProfileCompleted}
        />
      )}
      {dataActivate && (
        <PopupActivateEmployee
          isOpen={!!dataActivate}
          onClose={handleCloseActivate}
          onSubmit={handleActivateEmployee}
          defaultValues={dataActivate}
        />
      )}
      {/* form */}
      {dataDetail && (
        <FormInfo
          isOpen={!!dataDetail}
          onClose={handleCloseDetailEmployee}
          defaultValues={dataDetail}
        />
      )}
      {/* FilePopup */}
      {dataFilePopup && (
        <PopupFileDocument
          isOpen={!!dataFilePopup}
          onClose={handleCloseFilePopup}
          value={dataFilePopup}
          onSubmit={submitFileEmployee}
        />
      )}

      <DeleteDialog
        isOpen={isOpenDisbursement}
        onClose={handleCloseDisbursement}
        title={"Cập nhật trạng thái sở hữu CCMG"}
        description={`Bạn có muốn cập nhật trạng thái sở hữu CCMG của nhân viên ${dataEdit?.fullName} không ?`}
        action={() => handleDisbursementEmployee(dataEdit?.id)}
        textDelete={"Đã có"}
        textCancel={"Chưa có"}
        actionClose={() => handleCreateDisbursementEmployee(dataEdit?.id)}
      />
    </Flex>
  );
};

export default SalesRelative;
